import * as React from "react";
import ContactLayout from "./ContactLayout";

export const ContactIssuers = () => {
  return (
    <ContactLayout
      description="Say enables direct investor communications outside the pre-existing framework, giving companies and funds unprecedented, low-cost access to their shareholders that can be used for new marketing, investor relations, and stewardship applications."
      formPortalId="4597759"
      formId="e3104afc-23ce-403f-8541-8b361889e173"
      title={
        <h1>
          Say
          <sup>&#174;</sup> for Issuers
        </h1>
      }
      siteTitle="Say for Issuers"
    />
  );
};



// WEBPACK FOOTER //
// ./src/pages/Contact/ContactIssuers.tsx